import React, { FC, useCallback, useEffect, useState, useContext, useRef } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import { get, post } from "../fetchers/fetchers";

import { useParams } from "react-router";
import { API_URL, APPLICATION } from "../env";
import { get_query } from '../stateManagement/data';


import {
    Button,
    Chip,
    Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, TextField, TextFieldProps,
    Tooltip,
    Typography,
    withStyles
} from "@material-ui/core";
import {
    IControlMeasure,
    IControlMeasureFailureMode,
    IControlType, IDam, IDocument, IFailureMode, IFailureModeAssessment,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";
import ControlMeasure from "./control_measure";
import AddIcon from "@material-ui/icons/Add";
import DialogContentText from "@material-ui/core/DialogContentText";
import Documents from "./documents";
import AddControlMeasureDialog from "./add_ccontrol_measure_dialog";

import {getControlMeasures, getFailureModeControlMeasures} from "../stateManagement/data";
import { isNonNullChain } from 'typescript';

interface IControlMeasuresProps {
    existing: boolean
}

interface IRouteParams {
    id: string
}



const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);

const ControlMeasures: FC<IControlMeasuresProps> = ({ existing }) => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()
  
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [controlTypes, setControlTypes] = useState<IControlType[]>([]);
    const [controlMeasures, setControlMeasures] = useState<IControlMeasure[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [controlMeasureFailureMode, setControlMeasureFailureModes] = useState<IControlMeasureFailureMode[]>([])
    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const newControlMeasure = useRef<TextFieldProps>(null);
    const [documentRef, setDocumentRef] = useState<IDocument>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [failureModeAssessments, setFailureModeAssessments] = useState<IFailureModeAssessment[]>([]);
    const [write_access, setWriteAccess] = useState<boolean>(false);
    const [FMFilter, setFMFilter] = useState<string | null>(null);
    const [filteredFailureModes, setFilteredFailureModes] = useState<IProjectFailureMode[]>([]);


    useEffect(() => {
        if (tasks.loaded)
            {   
                setControlMeasures(tasks.controlMeasures)
                setControlTypes(tasks.controlTypes)
                setFailureModes(tasks.failureModes)
                setControlMeasureFailureModes(tasks.failureModeControlMeasures)
                setFailureModeAssessments(tasks.failureModeAssessments)}

    }, [tasks])

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    useEffect(() => {
        let filtered = failureModes.filter( (f) => {
            if (FMFilter === null) {
                if (f.failure_mode?.is_active) {
                    return true
                }
                return false
            }
            if (FMFilter === "Critical") {
                // get Failure Mode Assessment
                let fma = failureModeAssessments.find( (fa) => fa.project_failure_mode_id === f.id)
                
                if (fma?.consider) {
                    return true
                }
                return false
            }
            if (FMFilter === "Non Critical") {
                let fma = failureModeAssessments.find( (fa) => fa.project_failure_mode_id === f.id)
                if (fma?.consider) {
                    return false
                }
                return true
            }
            return false
        })
        
        setFilteredFailureModes(filtered)     
        
    } , [FMFilter, failureModes,failureModeAssessments])
    
    const params = useParams<IRouteParams>()

    const handleClose = () => {
        setOpenCreateDialog(false)
    }
    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const render_pill = (level: number, label: string, trigger: string| null) => {
        let color = "#535353";
        let alpha = FMFilter === trigger ? 1 : 0.1;
        let bcolor = "rgb(196,196,196," + alpha + ")";
        
        if (level === 3) {
            bcolor = "rgba(206,238,208," + alpha + ")";
            color = "rgb(48,104,33)";
        }
        if (level === 2) {
            bcolor = "rgba(206,238,208," + alpha + ")";
            color = "rgb(48,104,33)";
        }
        if (level === 1) {
            bcolor = "rgba(252,236,166," + alpha + ")";
            color = "rgb(152,96,34)";
        }
        if (level === 0) {
            bcolor = "rgba(251,84,81," + alpha + ")";
            color = "rgb(104,4,0)";
        }
    
        const chipStyle = {
            backgroundColor: bcolor,
            color: color,
            borderColor: color // Set the border color same as text color
        };
    
        return (
            <Tooltip title={label}>
                <Chip
                    size="small"
                    label={label}
                    style={chipStyle}
                    onClick={() => setFMFilter(trigger)}
                    variant={FMFilter === trigger ? "default" : "outlined"}
                />
            </Tooltip>
        );
    }

    const setFailureModeControlMeasures = async (failureModeControlMeasure: IControlMeasureFailureMode) => {
        let fcm = { ...failureModeControlMeasure };

        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            fcm["state_id"] = parseInt(query_params.state)
        }

        let d = await post<IControlMeasureFailureMode>(API_URL + "control_measures/failure_modes", fcm);
        let r = await getFailureModeControlMeasures(params.id,dispatch);
    }

    const postControlMeasure = async (controlMeasure: IControlMeasure) => {
        let cm = { ...controlMeasure };
        delete cm.document;
        delete cm.id;
        
        // check if states in params
        let query_params = get_query()
        
        // check if state key in params
        if (query_params.state) {
            cm["state_id"] = parseInt(query_params.state)
        }
        const d = await post<IControlMeasure>(API_URL + "control_measures/" + params.id.toString() + "/", cm)

        const e = await getControlMeasures(params.id,dispatch)

    }

    const updateFailureModeControlMeasures = useCallback((failureModeControlMeasures: IControlMeasureFailureMode) => {
        setFailureModeControlMeasures(failureModeControlMeasures).then(() => {
            setIsLoaded(false);
        })
    }, [setFailureModeControlMeasures, setIsLoaded]);

    const updateControlMeasures = useCallback((controlMeasure: IControlMeasure) => {
        postControlMeasure(controlMeasure).then(() => {
            setIsLoaded(false);
        })
    }, [postControlMeasure, setIsLoaded]);



    const getLinkedFailureModes = (control_measure_id: number): IControlMeasureFailureMode[] => {

        let f_modes = controlMeasureFailureMode.filter((c) =>
            c.control_measure_id === control_measure_id
        )
        return f_modes
    }

    const getPriority = (f: IProjectFailureMode): string => {
        const fma = failureModeAssessments.find( (fa) => fa.project_failure_mode_id === f.id)
        if (fma?.consider) {
            return "rgb(254,221,220)";
            
        }
        return "rgb(245,252,246)";
    }
    return (
        <div>
            {write_access && <Tooltip title="Add Control Measure" placement={'bottom-end'}>
                <AddingButton style={{
                    backgroundColor: "rgb(239,88,43)",
                    color: "rgb(255,255,255)"
                }} onClick={prevState => handleOpen()}>
                    <AddIcon fontSize="small" />
                </AddingButton>
            </Tooltip> }
            {openCreateDialog && <AddControlMeasureDialog controlMeasure={{
                uuid: -1,
                description: "",
                existing: existing,
                control_type_id: 0
            }} updateControlMeasure={updateControlMeasures} closeDialogCallback={handleClose} />}

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    {render_pill(4, "All", null)}
                    {render_pill(0, APPLICATION == "ALARP" ? "Priority": "Critical", "Critical")}
                    {render_pill(2, APPLICATION == "ALARP" ? "Non Priority": "Non Critical", "Non Critical")}
                </Grid>
            </Grid>
            <TableContainer style={{ maxHeight: "80vh",  overflowX: "auto", maxWidth: "100%" }}>
                <Table stickyHeader style={{zIndex:2}}>
                    
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ position: "sticky", left: 0, zIndex: 3 }}>Control Measure</TableCell>
                            <TableCell style={{ position: "sticky", left: "100px", zIndex: 3 }}>Description</TableCell>
                            <TableCell style={{ position: "sticky", left: "200px", zIndex: 3 }}>Control Type</TableCell>

                            {filteredFailureModes.map( (f) => 
                        
                               < TableCell style={{zIndex:  2, backgroundColor: getPriority(f)}}> {f.failure_mode?.name}</TableCell>
                            )}
                            <TableCell style={{zIndex: 2 }}>Reference</TableCell>
                            <TableCell style={{zIndex: 2 }}>Comments</TableCell>
                            <TableCell style={{zIndex: 2 }}>Controls</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {controlMeasures.filter((c) => c.existing === existing).map((c) => {
                            
                            if (!c.id) {
                                return <></>
                            }
                            return (
                                <ControlMeasure control_types={controlTypes}
                                    control_measure={c}
                                    failure_modes={filteredFailureModes}
                                    control_measure_failure_modes={getLinkedFailureModes(c.uuid)}
                                    updateFailureModeControlMeasures={updateFailureModeControlMeasures}
                                    updateControlMeasures={updateControlMeasures}
                                />
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>


        </div>
    );
}

export default ControlMeasures;

